import React, { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";

import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";
import { uiContainerTransitionMs } from "@src/utils";
import { Arrow, navArrowHoverStyles } from "./arrow";
import ServiceIcon from "../ServiceIcon";

interface MenuHighlightProps {
  itemTitle: string;
  subTitle?: string;
  url?: string;
  icon?: string;
}

const MenuHighlight: FC<MenuHighlightProps> = ({
  itemTitle,
  subTitle = "",
  url = "",
  icon = "",
}) => {
  return (
    <Stack
      component="a"
      href={url}
      gap="14px"
      direction="row"
      sx={{
        alignItems: "center",
        textDecoration: "none",
        ".nav-item-highlight-icon, .nav-item-highlight-subtitle": {
          color: Colors.TextSecondary,
          transition: `color ${uiContainerTransitionMs}ms ease-in-out`,
        },
        "&:hover": {
          textDecoration: "none",
          ".nav-item-highlight-icon, .nav-item-highlight-subtitle": {
            color: Colors.HeadingText,
          },
          ...navArrowHoverStyles,
        },
      }}
    >
      <ServiceIcon
        size={24}
        service={icon}
        className="nav-item-highlight-icon"
      />

      <Box>
        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "22px",
            color: Colors.HeadingText,
          }}
        >
          {itemTitle} <Arrow />
        </Typography>

        <Typography
          variant="body2"
          className="nav-item-highlight-subtitle"
          sx={{
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "20px",
          }}
        >
          {subTitle}
        </Typography>
      </Box>
    </Stack>
  );
};

export default MenuHighlight;
